import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { environment } from "src/environments/environment";
import { DeleteSubscriberModel } from "../../models/members/delete-subscriber.model";
import { SearchAppUserModel } from "../../models/members/search-app-user.model";
import { HttpService } from "../common/http-service";

const USER_API = environment.apiURL + '/api/adm/User/';
@Injectable({
    providedIn: 'root'
})
export class AppUserService {
    //#region Fields
    //#endregion

    //#region Constructor

    constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
    }
    //#endregion

    //#region Public Methods
    getalleventsubscibers(model: SearchAppUserModel) {
        var url = USER_API + "getalleventsubscibers";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getallresysubscribers(model: SearchAppUserModel) {
      var url = USER_API + "getallresysubscribers";
      return this._httpService.httpPost(url, model)
        .pipe(map(resposne => {
          return resposne;
        }));
    }
    getallposemployees(model: SearchAppUserModel) {
      var url = USER_API + "getallposemployes";
      return this._httpService.httpPost(url, model)
        .pipe(map(resposne => {
          return resposne;
        }));
    }
    getsubscriberbyId(id: string) {
        var url = USER_API + 'getsubscriber?subsciberId=' + id;
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    suspendsubscriber(model: DeleteSubscriberModel) {
        var url = USER_API + "suspendsubscriber";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    unsuspendsubscriber(model: DeleteSubscriberModel) {
        var url = USER_API + "unsuspendsubscriber";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    //#endregion
}
